import React, {useEffect, useRef, useState} from "react"
import {Link} from "react-router-dom"


const Vacancies = ({jobs}) => {

    const [height, setHeight] = useState(0)
    const [opened, toggle] = useState(false)

    const refContainer = useRef(null)

    useEffect(() => {
        setHeight(refContainer.current.scrollHeight)
    }, [])


    return (
        <div className={"stages-box offers jobs"}>
            <div onClick={() => toggle(!opened)} className={"box"}>
                <div className={"left-stages"}>
                    <img style={{transform: `rotate(${opened ? `0deg` : `180deg`})`, transition: "all 0.2s linear"}}
                         alt={"😼"}
                         src={"/Images/arrow-black.svg"}/>
                    <div className={"stages-name"}>
                        Вакансии
                    </div>
                    <span className={"offers-count"}>{jobs.length}</span>
                </div>

            </div>
            <div style={{maxHeight: `${opened ? `${height}px` : `0px`}`}} ref={refContainer} className={"themes-box"}>
                {jobs.map((item, index) => (
                    <Link to={`/jobs/${item.id}`} key={index} className={"themes-box__cell"}>
                        <div className={"offer-info"}>
                            <div className={"offer-info__top"}>
                                {item.position}
                            </div>
                            <div className={"offer-info__bottom"}>
                                <span>Компания: {item.company.name}</span>
                            </div>
                        </div>
                        <img src={`${item.company.logo}`} className={"offer-logo"} alt={"😼"}/>
                    </Link>
                ))}
            </div>

        </div>
    )
}


export default Vacancies